export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9604.032c2078.jpg";